import { createSlice } from '@reduxjs/toolkit';
import { UserUserinfoListApiResponse } from '@ports/internal-services/user/userSlice';
import type { RootState } from './store';

export type authStateType = {
  userData: UserUserinfoListApiResponse;
};

const initialState: authStateType = {
  userData: {} as UserUserinfoListApiResponse
};

export const userStateSlice = createSlice({
  name: 'userStateSlice',
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    resetUserData: () => {
      return initialState;
    }
  }
});

export const { setUserData, resetUserData } = userStateSlice.actions;
export const getUserData = (state: RootState) => state.userStateSlice?.userData;
